import { defineComponent, ref, nextTick, PropType } from 'vue';
import { ElMessage } from 'element-plus';
import { createDictionary, updateDictionary } from '@/api/system-config/index';
import { IUpdateDictionaryReq } from '@/api/system-config/type.d';
import { cloneDeep } from 'lodash-es';
import { DICTIONARY_CHANNEL_ENUM } from '@/constant';

export default defineComponent({
  emits: ['update:visible', 'success'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object as PropType<IUpdateDictionaryReq>,
    },
  },
  setup(props, { emit }) {
    const handleCloseDialog = () => {
      emit('update:visible', false);
    };

    const form = ref<IUpdateDictionaryReq>({
      dictId: '',
      code: '',
      name: '',
      channel: '',
      remark: '',
      sort: '',
      senderCode: '',
    });
    const refForm = ref<any | null>(null);
    const handleOpenDialog = async () => {
      try {
        await nextTick();
        (refForm.value as any).resetFields();
        form.value.dictId = props.formData?.dictId || '';
        form.value.code = props.formData?.code || '';
        form.value.name = props.formData?.name || '';
        form.value.channel = props.formData?.channel || DICTIONARY_CHANNEL_ENUM.BACKGROUND;
        form.value.remark = props.formData?.remark || '';
        form.value.sort = props.formData?.sort || '';
        form.value.senderCode = props.formData?.senderCode || 'LY';
      } catch (e) {
        console.log(e);
      }
    };
    // 保存
    const handleSave = async () => {
      try {
        await nextTick();
        await (refForm.value as any).validate();
        const params = cloneDeep(form.value);
        console.log(params);
        if (form.value.dictId) {
          await updateDictionary(params);
        } else {
          await createDictionary(params);
        }
        ElMessage.success('更新成功！');
        handleCloseDialog();
        emit('success');
      } catch (err) {
        console.log(err);
      }
    };
    return {
      handleCloseDialog,
      handleOpenDialog,
      form,
      refForm,
      handleSave,
      rules: {
        name: [
          {
            required: true,
            message: '字典名称不能为空',
          },
        ],
        code: [
          {
            required: true,
            message: '字典编码不能为空',
          },
        ],
        sort: [
          {
            validator: (rules: any, value: string, callback: (err?: string) => void) => {
              if (value !== '') {
                const val = Number(value);
                if (Number.isNaN(val)) {
                  callback('排序必须为数字');
                } else if (val < 0) {
                  callback('排序值不能小于0');
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  render() {
    return (
      <el-dialog
        title={this.form.dictId ? '编辑' : '新增'}
        modelValue={this.visible}
        onClose={this.handleCloseDialog}
        onOpen={this.handleOpenDialog}
        center
        width="500px"
        close-on-press-escape={false}
        close-on-click-modal={false}
        custom-class="dialog-width-medium el-dialog-inner-scroll"
        v-slots={{
          footer: () => (
            <div class="align-center">
              <el-button size="default" onClick={this.handleCloseDialog}>
                取 消
              </el-button>
              <el-button type="primary" size="default" onClick={this.handleSave}>
                保存
              </el-button>
            </div>
          ),
        }}
      >
        <el-form
          model={this.form}
          label-width="100px"
          style="width: 430px"
          size="default"
          rules={this.rules}
          ref="refForm"
        >
          <el-form-item label="字典名称：" prop="name">
            <el-input v-model={this.form.name} />
          </el-form-item>
          <el-form-item label="字典编码：" prop="code">
            <el-input v-model={this.form.code} disabled={!!this.form.dictId} />
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model={this.form.remark} />
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input v-model={[this.form.sort, ['number']]} />
          </el-form-item>
        </el-form>
      </el-dialog>
    );
  },
});
